import { useTranslation } from '@whoop/i18n/lang/client';
import type { ParsedBillingItem } from 'ui/types/cartTypes';

interface IBillingDetailsProps {
  billingDetails: ParsedBillingItem[];
  formatDisplayPrice: (price: number) => string;
}

const BillingDetails = ({
  billingDetails,
  formatDisplayPrice,
}: IBillingDetailsProps) => {
  const { t } = useTranslation('cart');
  return (
    <div className='mb-4 rounded'>
      <h3 className='mb-3 text-lg font-semibold'>{t('orderSummary')}</h3>
      {billingDetails.map((detail) => (
        <div className='mb-1 flex justify-between text-sm' key={detail.type}>
          <p className={`${detail.type.toLowerCase()}`}>{detail.title}:</p>
          <p className={`${detail.type.toLowerCase()} font-medium`}>
            {detail.value?.centAmount
              ? formatDisplayPrice(detail.value.centAmount)
              : '...'}
          </p>
        </div>
      ))}
    </div>
  );
};

export default BillingDetails;
